import { render, staticRenderFns } from "./TabLetter.vue?vue&type=template&id=1184fe3d&"
import script from "./TabLetter.vue?vue&type=script&lang=js&"
export * from "./TabLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports